import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EventManager, AccountService } from 'src/app/core';
import { UploadDocumentFundPopupComponent } from '../upload-document-fund-popup/upload-document-fund-popup.component';

const TABS = {
  EDIT_FUND: 'EDIT_FUND',
  UPLOAD_FILE: 'UPLOAD_FILE',
}
@Component({
  selector: 'app-tabs-edit-fund',
  templateUrl: './tabs-edit-fund.component.html',
  styleUrls: ['./tabs-edit-fund.component.scss']
})
export class TabsEditFundComponent implements OnInit {
  id: any;
  TABS = TABS;
  tab: string = TABS.EDIT_FUND;
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public route: ActivatedRoute,
    public modalService: NzModalService,
    public router: Router
  ) {
    
  }

  ngOnInit(): void {
    const params = this.route.snapshot.params;
    this.id = params.id;
  }
  changeTab($event) {
    this.tab = $event.index ? TABS.UPLOAD_FILE : TABS.EDIT_FUND;
  }
  openPopupUpload() {
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzOkDisabled: true,
      nzContent: UploadDocumentFundPopupComponent,
      nzFooter: null,
      nzData: {
        productId: this.id,
      },
      nzOnOk: (() => { })
    });
  }
}
